import { useEffect, useState } from "react";
import styled from "styled-components";
import { Subzone } from "../../../types/common.types";
import { useAdmin } from "../../../context/admin";
import { mobile } from "../../../styles/responsive";
import { MdEdit } from "react-icons/md";
import { FaTrash } from "react-icons/fa6";
import AdminService from "../../../services/admin.service";
import { useGlobal } from "../../../context/global";

export default function List() {
    const { setIsLoading } = useGlobal()
    const { setEditSubzoneId, subzonesZone } = useAdmin()
    const [list, setList] = useState<Subzone[]>([])

    useEffect(() => {
        async function getList() {
            setIsLoading(true)
            try {
                const response = (await AdminService.listSubzones(subzonesZone)).data
                setList(response)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        getList()
    }, [])

    async function deleteSubzone(id: string) {
        setIsLoading(true)
        try {
            await AdminService.deleteSubzone(id)
            window.location.reload()
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    if (!list.length) {
        return <Empty>Aún no hay subzonas en esta zona. Crea la primera con “Create Subzone”.</Empty>
    }

    return (
        <Main>
            {
                list.map((item, idx: number) => (
                    <div className="card-container" key={idx}>
                        <button type="button" className="edit"
                            onClick={() => setEditSubzoneId(item.id)}>
                            <MdEdit/>
                        </button>
                        <button type="button" className="delete"
                            onClick={() => deleteSubzone(item.id)}>
                            <FaTrash/>
                        </button>
                        <div className="card">
                            <h3 className="card__title">{item.nombre || item.id}</h3>
                            <p className="card__content">{item.overview_es || item.overview || item.id}</p>
                            <div className="card__date">Orden: {item.orden ?? 0}{item.navbar ? ' · navbar' : ''}</div>
                        </div>
                    </div>
                ))
            }
        </Main>
    )
}

const Empty = styled.p`
color: ${props => props.theme.grey};
font-size: 14px;
padding: 10px 2px;
`

const Main = styled.section`
display: grid;
grid-template-columns: repeat(2, minmax(200px, 1fr));
${mobile({ gridTemplateColumns: '1fr' })}
gap: 20px;
.card-container {
    position: relative;
    > button {
        z-index: 10;
        position: absolute;
        border-radius: 10px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all ease-in-out 0.2s;
        cursor: pointer;
        font-size: 18px;
        color: ${props => props.theme.white};
    }
    > button.edit {
        border: 2px solid ${props => props.theme.blueLight};
        background-color: ${props => props.theme.blueLight};
        right: 50px;
        top: 10px;
    }
    > button.edit:hover { background-color: ${props => props.theme.blue}; }
    > button.delete {
        background-color: ${props => props.theme.lightRed};
        border: 2px solid ${props => props.theme.lightRed};
        right: 10px;
        top: 10px;
    }
}
.card {
    font-family: "Arial";
    padding: 1rem;
    border-radius: 0.75rem;
    background: ${props => props.theme.whiteBackground};
    box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 3%);
    position: relative;
    overflow: hidden;
}
.card > * + * { margin-top: 1.1em; }
.card .card__content { color: var(--secondary-color); font-size: 0.86rem; }
.card .card__title { padding: 0; font-size: 1.3rem; font-weight: bold; }
.card .card__date { color: #6e6b80; font-size: 0.8rem; }
`
